<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ props }">
      <div v-bind="props">
        <v-select
            v-model="modelValue"
            :class="readonly ? 'custom-readonly' : ''"
            :items="items"
            :readonly="readonly"
            :variant="useGlobalSetting().globalTextVariant"
            label="Status"
            :prepend-icon="prependIcon"
            :disabled="disabled"
        >
          <template v-slot:item="{ props: itemProps, item }">
            <v-list-item
                v-if="StatePermission[item.raw] <= permission"
                :subtitle="StateDescription[item.raw]"
                v-bind="itemProps"
            ></v-list-item>
          </template>
        </v-select>
      </div>
    </template>
    <span>Status</span>
  </v-tooltip>
</template>

<script lang="ts" setup>
import {Groups, State, StateDescription, StatePermission} from "@/types/Order";
import {useGlobalSetting} from "@/lib/utils";
import {prop} from "vue-class-component";

interface Props {
  variant?: string,
  readonly?: boolean,
  prependIcon?: string,
  permission?: number,
  disabled?: boolean,
}

withDefaults(defineProps<Props>(), {
  readonly: false,
  prependIcon: "",
  permission: Groups.tde.permission,
  disabled: false,
})

const modelValue = defineModel<State>();

const items = Object.entries(State).map(([key, value]) => value)
</script>